

export interface IDiscounts {
    venue_id: string;
    code: string;
    value: number;
    minimum_order_value:number;  
    max_number_of_uses:number; 
    number_of_uses:number;
    type:IDiscountType; 
    created_on: string;
    enabled: boolean;
    description: string;
    id?: string;
    max_uses_per_consumer:number
}
export enum IDiscountType {
    VALUE = "ABSOLUTE",
    PERCENTAGE = "PERCENTAGE"
}